<h1 *header="'Address'; d9: '#block-pac-theme-pagetitle h1.title'; let title" class="page-header">{{ title }}</h1>

<app-signup-header></app-signup-header>

<div *ngIf="error" class="alert" [ngClass]="error.alertClass" role="alert">
  <ng-template [ngIf]="error.isString" [ngIfElse]="error.message">
    <p>{{ error.message }}</p>
  </ng-template>
</div>

<ng-container [ngTemplateOutlet]="show">

</ng-container>

<ng-template #choose>
  <form (ngSubmit)="OnContinue();">
    <app-address-preview title="Original Address" [address]="original" type="default" (edit)="edit($event)" (value)="address = $event"></app-address-preview>
    <app-address-preview title="Suggested Address" [address]="validated" type="primary" (edit)="edit($event)" (value)="address = $event"></app-address-preview>
    <div>
      <button class="btn btn-primary btn-lg" type="submit">Continue</button>
    </div>
  </form>
</ng-template>

<ng-template #form>
  <form (ngSubmit)="OnSubmit()">
      <fieldset bsMigration [bs3Class]="['panel-default']" [bs4Class]="['mb-3']" [formGroup]="group" class="panel" [disabled]="isSaving" #fieldset>
        <legend bsMigration class="panel-heading">Address Information</legend>
        <div bsMigration class="panel-body">
          <p>A valid address is required for signup.</p>
          <div class="form-group">
            <label for="input-country">Country</label>
            <select [bs3Class]="['form-control']" [bs4Class]="['form-select']" id="input-country" #inputCountry formControlName="adr_country" required (change)="isSaving = true; OnCountryChange.emit(group.value.adr_country);">
              <option [ngValue]="null"></option>
              <option *ngFor="let country of countries" [ngValue]="country">{{ country.cty_long_name }}</option>
            </select>
          </div>
          <app-dynamic-address [group]="group" [Country]="group.value.adr_country" [CountryChange]="OnCountryChange" [fieldset]="fieldset" [Address]="address" [AddressFields]="addressFields"></app-dynamic-address>
        </div>
      </fieldset>

      <app-phone *ngIf="group.value.adr_country?.cty_iso_2 == 'US'" [isSaving]="isSaving" [OnSaveEvent]="OnSavePhone" [Country]="group.value.adr_country"></app-phone>

      <p>
        <button type="submit" [bs5Class]="['me-2']" class="btn btn-primary btn-lg" [disabled]="!valid || isSaving">{{ mustValidate ? 'Validate Address' : 'Continue' }}</button>
        <button bsMigration type="button" [bs5Class]="['me-2']" class="btn btn-default btn-lg" *ngIf="mustValidate && !group.pristine" (click)="OnUseUnvalidated()" [disabled]="!valid || isSaving">Skip Validation</button>
        <button type="button" [bs5Class]="['me-2']" class="btn btn-info btn-lg" *ngIf="canSkip" (click)="OnSkip()" [disabled]="!valid || isSaving">Keep Existing</button>
        <button bsMigration type="button" [bs5Class]="['me-2']" class="btn btn-default btn-lg" *ngIf="showOriginal" (click)="OnUseOriginal()" [disabled]="!valid || isSaving">Use Original</button>
      </p>
    </form>
</ng-template>

<ng-template #msgNoAddress>
  <p>Warning: We could not validate your address. Please ensure the information is correct before proceeding.</p>
</ng-template>

<ng-template #msgValidated>
  <p>We may have found a better match for your address that complies with the U.S. Postal Service (USPS) standards.</p>
</ng-template>
